import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  DateTime: any;
};

export type AuthorStats = {
  __typename?: 'AuthorStats';
  count: Scalars['Int'];
  user: User;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type Coin = {
  __typename?: 'Coin';
  current_price: Scalars['Float'];
  id: Scalars['String'];
  price_change_24h: Scalars['Float'];
  price_change_percentage_24h: Scalars['Float'];
  symbol: Scalars['String'];
};

export type File = {
  __typename?: 'File';
  filesize?: Maybe<Scalars['BigInt']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  flush: Scalars['Boolean'];
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Page = {
  __typename?: 'Page';
  authors: Array<User>;
  codeFoot: Scalars['String'];
  codeHead: Scalars['String'];
  custom_excerpt?: Maybe<Scalars['String']>;
  custom_template?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  id: Scalars['String'];
  pageviews: Scalars['Int'];
  picture?: Maybe<File>;
  published_at?: Maybe<Scalars['DateTime']>;
  readingTime: Scalars['String'];
  seo: Seo;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nextPage?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  previousPage?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PageWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Post = {
  __typename?: 'Post';
  authors: Array<User>;
  codeFoot: Scalars['String'];
  codeHead: Scalars['String'];
  custom_template?: Maybe<Scalars['String']>;
  excerpt: Scalars['String'];
  html: Scalars['String'];
  id: Scalars['String'];
  pageviews: Scalars['Int'];
  picture?: Maybe<File>;
  published_at?: Maybe<Scalars['DateTime']>;
  readingTime: Scalars['Int'];
  seo: Seo;
  slug: Scalars['String'];
  tags: Array<Tag>;
  title: Scalars['String'];
};

export type PostConnection = {
  __typename?: 'PostConnection';
  nodes: Array<Post>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PostWhereInput = {
  author_id?: InputMaybe<StringFilter>;
  author_slug?: InputMaybe<StringFilter>;
  featured?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  tag_id?: InputMaybe<StringFilter>;
  tag_slug?: InputMaybe<StringFilter>;
  tag_slug_not?: InputMaybe<StringFilter>;
};

export type PostWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  _posts: PostConnection;
  _tags: TagConnection;
  coins: Array<Coin>;
  nowReadingPosts?: Maybe<Array<Post>>;
  page?: Maybe<Page>;
  post?: Maybe<Post>;
  posts?: Maybe<Array<Post>>;
  settings: Settings;
  tag?: Maybe<Tag>;
  tags?: Maybe<Array<Tag>>;
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
};


export type Query_PostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
  where?: InputMaybe<PostWhereInput>;
};


export type Query_TagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryPageArgs = {
  where: PageWhereUniqueInput;
};


export type QueryPostArgs = {
  where: PostWhereUniqueInput;
};


export type QueryPostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
  where?: InputMaybe<PostWhereInput>;
};


export type QueryTagArgs = {
  where: TagWhereUniqueInput;
};


export type QueryTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type Seo = {
  __typename?: 'Seo';
  description: Scalars['String'];
  image?: Maybe<File>;
  title: Scalars['String'];
};

export type Settings = {
  __typename?: 'Settings';
  coverImage?: Maybe<File>;
  description?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  ogDescription?: Maybe<Scalars['String']>;
  ogImage?: Maybe<File>;
  ogTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  authorsStats: Array<AuthorStats>;
  countPosts: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  seo: Seo;
  slug: Scalars['String'];
};


export type TagAuthorsStatsArgs = {
  author_id?: InputMaybe<StringFilter>;
  take?: InputMaybe<Scalars['Int']>;
};

export type TagConnection = {
  __typename?: 'TagConnection';
  nodes: Array<Tag>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TagWhereInput = {
  id?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringNullableFilter>;
};

export type TagWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  bio?: Maybe<Scalars['String']>;
  countPosts: Scalars['Int'];
  cover?: Maybe<File>;
  facebook?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  picture?: Maybe<File>;
  seo: Seo;
  slug: Scalars['String'];
  twitter?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};


export type UserCountPostsArgs = {
  tag_id?: InputMaybe<StringFilter>;
  tag_slug?: InputMaybe<StringFilter>;
};

export type UserWhereInput = {
  id?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringNullableFilter>;
};

export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type AuthorsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorsListQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, slug: string }> | null };

export type AuthorQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type AuthorQuery = { __typename?: 'Query', authorData?: { __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null } } | null };

export type AuthorsPostsQueryVariables = Exact<{
  where?: InputMaybe<PostWhereInput>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AuthorsPostsQuery = { __typename?: 'Query', postsData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type BlogsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
}>;


export type BlogsQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', id: string, name: string, slug: string, countPosts: number, authorsStats: Array<{ __typename?: 'AuthorStats', count: number, user: { __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, countPosts: number, cover?: { __typename?: 'File', id: string, url: string } | null, picture?: { __typename?: 'File', id: string, url: string } | null } }> } | null };

export type NowReadingQueryVariables = Exact<{ [key: string]: never; }>;


export type NowReadingQuery = { __typename?: 'Query', nowReadingPosts?: Array<{ __typename?: 'Post', id: string, title: string, slug: string, excerpt: string, published_at?: any | null, readingTime: number, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, picture?: { __typename?: 'File', id: string, url: string } | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null } }> }> | null };

export type CoinsQueryVariables = Exact<{ [key: string]: never; }>;


export type CoinsQuery = { __typename?: 'Query', coins: Array<{ __typename?: 'Coin', id: string, symbol: string, current_price: number, price_change_24h: number, price_change_percentage_24h: number }> };

export type DetailPostQueryVariables = Exact<{
  where: PostWhereUniqueInput;
}>;


export type DetailPostQuery = { __typename?: 'Query', post?: { __typename?: 'Post', id: string, title: string, slug: string, published_at?: any | null, custom_template?: string | null, html: string, excerpt: string, pageviews: number, readingTime: number, codeHead: string, codeFoot: string, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, picture?: { __typename?: 'File', id: string, url: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> } | null };

export type DetailPageQueryVariables = Exact<{
  where: PageWhereUniqueInput;
}>;


export type DetailPageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', id: string, title: string, slug: string, published_at?: any | null, custom_template?: string | null, html: string, custom_excerpt?: string | null, readingTime: string, codeHead: string, codeFoot: string, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> } | null };

export type NewsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsQuery = { __typename?: 'Query', newsData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type GetPostsQueryVariables = Exact<{
  take: Scalars['Int'];
}>;


export type GetPostsQuery = { __typename?: 'Query', posts?: Array<{ __typename?: 'Post', id: string, title: string, slug: string, published_at?: any | null, custom_template?: string | null, excerpt: string, picture?: { __typename?: 'File', url: string, id: string } | null }> | null };

export type GetCountPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountPostsQuery = { __typename?: 'Query', articlesDataSt?: { __typename?: 'Tag', countPosts: number, slug: string, id: string } | null, articlesDataTg?: { __typename?: 'Tag', countPosts: number, slug: string, id: string } | null, articlesDataReviews?: { __typename?: 'Tag', countPosts: number, slug: string, id: string } | null, articlesDataIn?: { __typename?: 'Tag', countPosts: number, slug: string, id: string } | null, articlesDataBlog?: { __typename?: 'Tag', countPosts: number, slug: string, id: string } | null, telegramData?: { __typename?: 'Tag', countPosts: number, slug: string, id: string } | null, reviewsData?: { __typename?: 'Tag', countPosts: number, slug: string, id: string } | null, blogsData?: { __typename?: 'Tag', countPosts: number, slug: string, id: string } | null };

export type MainPageInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MainPageInfoQuery = { __typename?: 'Query', telegramData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> }, reviewsData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> }, interviewData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> }, stData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type MainArticleQueryVariables = Exact<{ [key: string]: never; }>;


export type MainArticleQuery = { __typename?: 'Query', mainArticleData: { __typename?: 'PostConnection', nodes: Array<{ __typename?: 'Post', html: string, id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type ArticlesAndNewsQueryVariables = Exact<{
  skipArticles?: InputMaybe<Scalars['Int']>;
}>;


export type ArticlesAndNewsQuery = { __typename?: 'Query', newsData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> }, articlesData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type ImageFragment = { __typename?: 'File', id: string, url: string };

export type PageInfoFragment = { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean };

export type PostFragment = { __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> };

export type PostWithHtmlFragment = { __typename?: 'Post', html: string, id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> };

export type PostsQueryVariables = Exact<{
  count: Scalars['Int'];
  where?: InputMaybe<PostWhereInput>;
}>;


export type PostsQuery = { __typename?: 'Query', _posts: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type SeoQueryVariables = Exact<{ [key: string]: never; }>;


export type SeoQuery = { __typename?: 'Query', settings: { __typename?: 'Settings', title?: string | null, description?: string | null, metaTitle?: string | null, ogTitle?: string | null, metaDescription?: string | null, ogDescription?: string | null, coverImage?: { __typename?: 'File', url: string } | null, ogImage?: { __typename?: 'File', url: string } | null } };

export type SpecialQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type SpecialQuery = { __typename?: 'Query', page?: { __typename?: 'Page', id: string, slug: string, readingTime: string } | null };

export type TagQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type TagQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', id: string, name: string, slug: string, description?: string | null, countPosts: number, seo: { __typename?: 'Seo', title: string, description: string } } | null };

export type TagPostsCountQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type TagPostsCountQuery = { __typename?: 'Query', tagCount?: { __typename?: 'Tag', id: string, slug: string, countPosts: number } | null };

export type PreviewPostFragment = { __typename?: 'Post', id: string, title: string, slug: string, excerpt: string, published_at?: any | null, readingTime: number, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, picture?: { __typename?: 'File', id: string, url: string } | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null } }> };

export type PreviewPostWithHtmlFragment = { __typename?: 'Post', html: string, id: string, title: string, slug: string, excerpt: string, published_at?: any | null, readingTime: number, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, picture?: { __typename?: 'File', id: string, url: string } | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null } }> };

export type MainTagPostQueryVariables = Exact<{
  where?: InputMaybe<PostWhereInput>;
}>;


export type MainTagPostQuery = { __typename?: 'Query', post: { __typename?: 'PostConnection', nodes: Array<{ __typename?: 'Post', html: string, id: string, title: string, slug: string, excerpt: string, published_at?: any | null, readingTime: number, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, picture?: { __typename?: 'File', id: string, url: string } | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null } }> }> } };

export type TagPostsQueryVariables = Exact<{
  where?: InputMaybe<PostWhereInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
}>;


export type TagPostsQuery = { __typename?: 'Query', posts: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, excerpt: string, published_at?: any | null, readingTime: number, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, picture?: { __typename?: 'File', id: string, url: string } | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null } }> }> } };

export type JobsAndWorksQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsAndWorksQuery = { __typename?: 'Query', workArticlesData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> }, jobsData: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type MainWorkArticleQueryVariables = Exact<{ [key: string]: never; }>;


export type MainWorkArticleQuery = { __typename?: 'Query', _posts: { __typename?: 'PostConnection', nodes: Array<{ __typename?: 'Post', html: string, id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type WorkArticlesQueryVariables = Exact<{
  cursor?: InputMaybe<PostWhereUniqueInput>;
  take: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type WorkArticlesQuery = { __typename?: 'Query', _posts: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export type JobsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsQuery = { __typename?: 'Query', _posts: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', page?: number | null, totalPages: number, count: number, totalCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Post', id: string, title: string, slug: string, pageviews: number, readingTime: number, excerpt: string, published_at?: any | null, custom_template?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }>, picture?: { __typename?: 'File', id: string, url: string } | null, authors: Array<{ __typename?: 'User', id: string, name: string, slug: string, bio?: string | null, website?: string | null, facebook?: string | null, twitter?: string | null, seo: { __typename?: 'Seo', title: string, description: string, image?: { __typename?: 'File', id: string, url: string } | null }, picture?: { __typename?: 'File', id: string, url: string } | null, cover?: { __typename?: 'File', id: string, url: string } | null }> }> } };

export const PageInfoFragmentDoc = gql`
    fragment pageInfo on PageInfo {
  page
  totalPages
  count
  totalCount
  nextPage
  previousPage
  hasNextPage
  hasPreviousPage
}
    `;
export const ImageFragmentDoc = gql`
    fragment image on File {
  id
  url
}
    `;
export const PostFragmentDoc = gql`
    fragment post on Post {
  id
  title
  slug
  pageviews
  readingTime
  excerpt
  published_at
  custom_template
  tags {
    id
    name
    slug
  }
  picture {
    ...image
  }
  authors {
    id
    name
    slug
    bio
    seo {
      title
      description
      image {
        ...image
      }
    }
    website
    picture {
      ...image
    }
    cover {
      ...image
    }
    facebook
    twitter
  }
}
    ${ImageFragmentDoc}`;
export const PostWithHtmlFragmentDoc = gql`
    fragment postWithHtml on Post {
  ...post
  html
}
    ${PostFragmentDoc}`;
export const PreviewPostFragmentDoc = gql`
    fragment previewPost on Post {
  id
  title
  slug
  excerpt
  published_at
  readingTime
  tags {
    id
    name
    slug
  }
  picture {
    ...image
  }
  authors {
    id
    name
    slug
    picture {
      ...image
    }
    seo {
      title
      description
      image {
        ...image
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const PreviewPostWithHtmlFragmentDoc = gql`
    fragment previewPostWithHtml on Post {
  ...previewPost
  html
}
    ${PreviewPostFragmentDoc}`;
export const AuthorsListDocument = gql`
    query AuthorsList {
  users {
    id
    slug
  }
}
    `;

/**
 * __useAuthorsListQuery__
 *
 * To run a query within a React component, call `useAuthorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthorsListQuery(baseOptions?: Apollo.QueryHookOptions<AuthorsListQuery, AuthorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorsListQuery, AuthorsListQueryVariables>(AuthorsListDocument, options);
      }
export function useAuthorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorsListQuery, AuthorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorsListQuery, AuthorsListQueryVariables>(AuthorsListDocument, options);
        }
export type AuthorsListQueryHookResult = ReturnType<typeof useAuthorsListQuery>;
export type AuthorsListLazyQueryHookResult = ReturnType<typeof useAuthorsListLazyQuery>;
export type AuthorsListQueryResult = Apollo.QueryResult<AuthorsListQuery, AuthorsListQueryVariables>;
export const AuthorDocument = gql`
    query Author($slug: String) {
  authorData: user(where: {slug: $slug}) {
    id
    name
    slug
    bio
    picture {
      ...image
    }
    cover {
      ...image
    }
    website
    facebook
    twitter
    seo {
      title
      description
      image {
        ...image
      }
    }
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useAuthorQuery__
 *
 * To run a query within a React component, call `useAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAuthorQuery(baseOptions?: Apollo.QueryHookOptions<AuthorQuery, AuthorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorQuery, AuthorQueryVariables>(AuthorDocument, options);
      }
export function useAuthorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorQuery, AuthorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorQuery, AuthorQueryVariables>(AuthorDocument, options);
        }
export type AuthorQueryHookResult = ReturnType<typeof useAuthorQuery>;
export type AuthorLazyQueryHookResult = ReturnType<typeof useAuthorLazyQuery>;
export type AuthorQueryResult = Apollo.QueryResult<AuthorQuery, AuthorQueryVariables>;
export const AuthorsPostsDocument = gql`
    query AuthorsPosts($where: PostWhereInput, $skip: Int) {
  postsData: _posts(take: 12, where: $where, skip: $skip) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
}
    ${PageInfoFragmentDoc}
${PostFragmentDoc}`;

/**
 * __useAuthorsPostsQuery__
 *
 * To run a query within a React component, call `useAuthorsPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorsPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorsPostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAuthorsPostsQuery(baseOptions?: Apollo.QueryHookOptions<AuthorsPostsQuery, AuthorsPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorsPostsQuery, AuthorsPostsQueryVariables>(AuthorsPostsDocument, options);
      }
export function useAuthorsPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorsPostsQuery, AuthorsPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorsPostsQuery, AuthorsPostsQueryVariables>(AuthorsPostsDocument, options);
        }
export type AuthorsPostsQueryHookResult = ReturnType<typeof useAuthorsPostsQuery>;
export type AuthorsPostsLazyQueryHookResult = ReturnType<typeof useAuthorsPostsLazyQuery>;
export type AuthorsPostsQueryResult = Apollo.QueryResult<AuthorsPostsQuery, AuthorsPostsQueryVariables>;
export const BlogsDocument = gql`
    query Blogs($take: Int) {
  tag(where: {slug: "blog"}) {
    id
    name
    slug
    countPosts
    authorsStats(take: $take) {
      user {
        id
        name
        slug
        bio
        countPosts
        cover {
          id
          url
        }
        picture {
          id
          url
        }
      }
      count
    }
  }
}
    `;

/**
 * __useBlogsQuery__
 *
 * To run a query within a React component, call `useBlogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogsQuery({
 *   variables: {
 *      take: // value for 'take'
 *   },
 * });
 */
export function useBlogsQuery(baseOptions?: Apollo.QueryHookOptions<BlogsQuery, BlogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogsQuery, BlogsQueryVariables>(BlogsDocument, options);
      }
export function useBlogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogsQuery, BlogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogsQuery, BlogsQueryVariables>(BlogsDocument, options);
        }
export type BlogsQueryHookResult = ReturnType<typeof useBlogsQuery>;
export type BlogsLazyQueryHookResult = ReturnType<typeof useBlogsLazyQuery>;
export type BlogsQueryResult = Apollo.QueryResult<BlogsQuery, BlogsQueryVariables>;
export const NowReadingDocument = gql`
    query NowReading {
  nowReadingPosts {
    ...previewPost
  }
}
    ${PreviewPostFragmentDoc}`;

/**
 * __useNowReadingQuery__
 *
 * To run a query within a React component, call `useNowReadingQuery` and pass it any options that fit your needs.
 * When your component renders, `useNowReadingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNowReadingQuery({
 *   variables: {
 *   },
 * });
 */
export function useNowReadingQuery(baseOptions?: Apollo.QueryHookOptions<NowReadingQuery, NowReadingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NowReadingQuery, NowReadingQueryVariables>(NowReadingDocument, options);
      }
export function useNowReadingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NowReadingQuery, NowReadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NowReadingQuery, NowReadingQueryVariables>(NowReadingDocument, options);
        }
export type NowReadingQueryHookResult = ReturnType<typeof useNowReadingQuery>;
export type NowReadingLazyQueryHookResult = ReturnType<typeof useNowReadingLazyQuery>;
export type NowReadingQueryResult = Apollo.QueryResult<NowReadingQuery, NowReadingQueryVariables>;
export const CoinsDocument = gql`
    query coins {
  coins {
    id
    symbol
    current_price
    price_change_24h
    price_change_percentage_24h
  }
}
    `;

/**
 * __useCoinsQuery__
 *
 * To run a query within a React component, call `useCoinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoinsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoinsQuery(baseOptions?: Apollo.QueryHookOptions<CoinsQuery, CoinsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoinsQuery, CoinsQueryVariables>(CoinsDocument, options);
      }
export function useCoinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoinsQuery, CoinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoinsQuery, CoinsQueryVariables>(CoinsDocument, options);
        }
export type CoinsQueryHookResult = ReturnType<typeof useCoinsQuery>;
export type CoinsLazyQueryHookResult = ReturnType<typeof useCoinsLazyQuery>;
export type CoinsQueryResult = Apollo.QueryResult<CoinsQuery, CoinsQueryVariables>;
export const DetailPostDocument = gql`
    query DetailPost($where: PostWhereUniqueInput!) {
  post(where: $where) {
    id
    title
    slug
    published_at
    custom_template
    seo {
      title
      description
      image {
        ...image
      }
    }
    picture {
      ...image
    }
    html
    excerpt
    authors {
      id
      name
      slug
      picture {
        ...image
      }
    }
    tags {
      id
      name
      slug
    }
    pageviews
    readingTime
    codeHead
    codeFoot
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useDetailPostQuery__
 *
 * To run a query within a React component, call `useDetailPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailPostQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDetailPostQuery(baseOptions: Apollo.QueryHookOptions<DetailPostQuery, DetailPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailPostQuery, DetailPostQueryVariables>(DetailPostDocument, options);
      }
export function useDetailPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailPostQuery, DetailPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailPostQuery, DetailPostQueryVariables>(DetailPostDocument, options);
        }
export type DetailPostQueryHookResult = ReturnType<typeof useDetailPostQuery>;
export type DetailPostLazyQueryHookResult = ReturnType<typeof useDetailPostLazyQuery>;
export type DetailPostQueryResult = Apollo.QueryResult<DetailPostQuery, DetailPostQueryVariables>;
export const DetailPageDocument = gql`
    query DetailPage($where: PageWhereUniqueInput!) {
  page(where: $where) {
    id
    title
    slug
    published_at
    custom_template
    seo {
      title
      description
      image {
        ...image
      }
    }
    picture {
      ...image
    }
    html
    custom_excerpt
    authors {
      id
      name
      slug
      picture {
        ...image
      }
      cover {
        ...image
      }
    }
    readingTime
    codeHead
    codeFoot
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useDetailPageQuery__
 *
 * To run a query within a React component, call `useDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailPageQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDetailPageQuery(baseOptions: Apollo.QueryHookOptions<DetailPageQuery, DetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailPageQuery, DetailPageQueryVariables>(DetailPageDocument, options);
      }
export function useDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailPageQuery, DetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailPageQuery, DetailPageQueryVariables>(DetailPageDocument, options);
        }
export type DetailPageQueryHookResult = ReturnType<typeof useDetailPageQuery>;
export type DetailPageLazyQueryHookResult = ReturnType<typeof useDetailPageLazyQuery>;
export type DetailPageQueryResult = Apollo.QueryResult<DetailPageQuery, DetailPageQueryVariables>;
export const NewsDocument = gql`
    query News {
  newsData: _posts(take: 10, where: {tag_slug: {equals: "news"}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
}
    ${PageInfoFragmentDoc}
${PostFragmentDoc}`;

/**
 * __useNewsQuery__
 *
 * To run a query within a React component, call `useNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewsQuery(baseOptions?: Apollo.QueryHookOptions<NewsQuery, NewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsQuery, NewsQueryVariables>(NewsDocument, options);
      }
export function useNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsQuery, NewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsQuery, NewsQueryVariables>(NewsDocument, options);
        }
export type NewsQueryHookResult = ReturnType<typeof useNewsQuery>;
export type NewsLazyQueryHookResult = ReturnType<typeof useNewsLazyQuery>;
export type NewsQueryResult = Apollo.QueryResult<NewsQuery, NewsQueryVariables>;
export const GetPostsDocument = gql`
    query GetPosts($take: Int!) {
  posts(take: $take) {
    id
    title
    slug
    picture {
      url
      id
    }
    published_at
    custom_template
    excerpt
  }
}
    `;

/**
 * __useGetPostsQuery__
 *
 * To run a query within a React component, call `useGetPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsQuery({
 *   variables: {
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPostsQuery(baseOptions: Apollo.QueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
      }
export function useGetPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
        }
export type GetPostsQueryHookResult = ReturnType<typeof useGetPostsQuery>;
export type GetPostsLazyQueryHookResult = ReturnType<typeof useGetPostsLazyQuery>;
export type GetPostsQueryResult = Apollo.QueryResult<GetPostsQuery, GetPostsQueryVariables>;
export const GetCountPostsDocument = gql`
    query GetCountPosts {
  articlesDataSt: tag(where: {slug: "st"}) {
    countPosts
    slug
    id
  }
  articlesDataTg: tag(where: {slug: "tg"}) {
    countPosts
    slug
    id
  }
  articlesDataReviews: tag(where: {slug: "reviews"}) {
    countPosts
    slug
    id
  }
  articlesDataIn: tag(where: {slug: "in"}) {
    countPosts
    slug
    id
  }
  articlesDataBlog: tag(where: {slug: "blog"}) {
    countPosts
    slug
    id
  }
  telegramData: tag(where: {slug: "tg"}) {
    countPosts
    slug
    id
  }
  reviewsData: tag(where: {slug: "reviews"}) {
    countPosts
    slug
    id
  }
  blogsData: tag(where: {slug: "blog"}) {
    countPosts
    slug
    id
  }
}
    `;

/**
 * __useGetCountPostsQuery__
 *
 * To run a query within a React component, call `useGetCountPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetCountPostsQuery, GetCountPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountPostsQuery, GetCountPostsQueryVariables>(GetCountPostsDocument, options);
      }
export function useGetCountPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountPostsQuery, GetCountPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountPostsQuery, GetCountPostsQueryVariables>(GetCountPostsDocument, options);
        }
export type GetCountPostsQueryHookResult = ReturnType<typeof useGetCountPostsQuery>;
export type GetCountPostsLazyQueryHookResult = ReturnType<typeof useGetCountPostsLazyQuery>;
export type GetCountPostsQueryResult = Apollo.QueryResult<GetCountPostsQuery, GetCountPostsQueryVariables>;
export const MainPageInfoDocument = gql`
    query MainPageInfo {
  telegramData: _posts(take: 10, where: {tag_slug: {in: ["tg"]}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
  reviewsData: _posts(take: 10, where: {tag_slug: {in: "reviews"}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
  interviewData: _posts(take: 10, where: {tag_slug: {in: "in"}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
  stData: _posts(take: 10, where: {tag_slug: {in: "st"}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
}
    ${PageInfoFragmentDoc}
${PostFragmentDoc}`;

/**
 * __useMainPageInfoQuery__
 *
 * To run a query within a React component, call `useMainPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainPageInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainPageInfoQuery(baseOptions?: Apollo.QueryHookOptions<MainPageInfoQuery, MainPageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainPageInfoQuery, MainPageInfoQueryVariables>(MainPageInfoDocument, options);
      }
export function useMainPageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainPageInfoQuery, MainPageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainPageInfoQuery, MainPageInfoQueryVariables>(MainPageInfoDocument, options);
        }
export type MainPageInfoQueryHookResult = ReturnType<typeof useMainPageInfoQuery>;
export type MainPageInfoLazyQueryHookResult = ReturnType<typeof useMainPageInfoLazyQuery>;
export type MainPageInfoQueryResult = Apollo.QueryResult<MainPageInfoQuery, MainPageInfoQueryVariables>;
export const MainArticleDocument = gql`
    query MainArticle {
  mainArticleData: _posts(
    take: 1
    where: {tag_slug_not: {in: ["news", "blog", "jobs"]}}
  ) {
    nodes {
      ...postWithHtml
    }
  }
}
    ${PostWithHtmlFragmentDoc}`;

/**
 * __useMainArticleQuery__
 *
 * To run a query within a React component, call `useMainArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainArticleQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainArticleQuery(baseOptions?: Apollo.QueryHookOptions<MainArticleQuery, MainArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainArticleQuery, MainArticleQueryVariables>(MainArticleDocument, options);
      }
export function useMainArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainArticleQuery, MainArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainArticleQuery, MainArticleQueryVariables>(MainArticleDocument, options);
        }
export type MainArticleQueryHookResult = ReturnType<typeof useMainArticleQuery>;
export type MainArticleLazyQueryHookResult = ReturnType<typeof useMainArticleLazyQuery>;
export type MainArticleQueryResult = Apollo.QueryResult<MainArticleQuery, MainArticleQueryVariables>;
export const ArticlesAndNewsDocument = gql`
    query ArticlesAndNews($skipArticles: Int = 1) {
  newsData: _posts(take: 6, where: {tag_slug: {equals: "news"}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
  articlesData: _posts(
    take: 4
    skip: $skipArticles
    where: {tag_slug_not: {in: ["news", "blog", "jobs"]}}
  ) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
}
    ${PageInfoFragmentDoc}
${PostFragmentDoc}`;

/**
 * __useArticlesAndNewsQuery__
 *
 * To run a query within a React component, call `useArticlesAndNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesAndNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesAndNewsQuery({
 *   variables: {
 *      skipArticles: // value for 'skipArticles'
 *   },
 * });
 */
export function useArticlesAndNewsQuery(baseOptions?: Apollo.QueryHookOptions<ArticlesAndNewsQuery, ArticlesAndNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticlesAndNewsQuery, ArticlesAndNewsQueryVariables>(ArticlesAndNewsDocument, options);
      }
export function useArticlesAndNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticlesAndNewsQuery, ArticlesAndNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticlesAndNewsQuery, ArticlesAndNewsQueryVariables>(ArticlesAndNewsDocument, options);
        }
export type ArticlesAndNewsQueryHookResult = ReturnType<typeof useArticlesAndNewsQuery>;
export type ArticlesAndNewsLazyQueryHookResult = ReturnType<typeof useArticlesAndNewsLazyQuery>;
export type ArticlesAndNewsQueryResult = Apollo.QueryResult<ArticlesAndNewsQuery, ArticlesAndNewsQueryVariables>;
export const PostsDocument = gql`
    query Posts($count: Int!, $where: PostWhereInput) {
  _posts(take: $count, where: $where) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
}
    ${PageInfoFragmentDoc}
${PostFragmentDoc}`;

/**
 * __usePostsQuery__
 *
 * To run a query within a React component, call `usePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsQuery({
 *   variables: {
 *      count: // value for 'count'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePostsQuery(baseOptions: Apollo.QueryHookOptions<PostsQuery, PostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
      }
export function usePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsQuery, PostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
        }
export type PostsQueryHookResult = ReturnType<typeof usePostsQuery>;
export type PostsLazyQueryHookResult = ReturnType<typeof usePostsLazyQuery>;
export type PostsQueryResult = Apollo.QueryResult<PostsQuery, PostsQueryVariables>;
export const SeoDocument = gql`
    query Seo {
  settings {
    title
    description
    coverImage {
      url
    }
    ogImage {
      url
    }
    metaTitle
    ogTitle
    metaDescription
    ogDescription
  }
}
    `;

/**
 * __useSeoQuery__
 *
 * To run a query within a React component, call `useSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSeoQuery(baseOptions?: Apollo.QueryHookOptions<SeoQuery, SeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeoQuery, SeoQueryVariables>(SeoDocument, options);
      }
export function useSeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeoQuery, SeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeoQuery, SeoQueryVariables>(SeoDocument, options);
        }
export type SeoQueryHookResult = ReturnType<typeof useSeoQuery>;
export type SeoLazyQueryHookResult = ReturnType<typeof useSeoLazyQuery>;
export type SeoQueryResult = Apollo.QueryResult<SeoQuery, SeoQueryVariables>;
export const SpecialDocument = gql`
    query Special($slug: String) {
  page(where: {slug: $slug}) {
    id
    slug
    readingTime
  }
}
    `;

/**
 * __useSpecialQuery__
 *
 * To run a query within a React component, call `useSpecialQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSpecialQuery(baseOptions?: Apollo.QueryHookOptions<SpecialQuery, SpecialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialQuery, SpecialQueryVariables>(SpecialDocument, options);
      }
export function useSpecialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialQuery, SpecialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialQuery, SpecialQueryVariables>(SpecialDocument, options);
        }
export type SpecialQueryHookResult = ReturnType<typeof useSpecialQuery>;
export type SpecialLazyQueryHookResult = ReturnType<typeof useSpecialLazyQuery>;
export type SpecialQueryResult = Apollo.QueryResult<SpecialQuery, SpecialQueryVariables>;
export const TagDocument = gql`
    query Tag($slug: String) {
  tag(where: {slug: $slug}) {
    id
    name
    slug
    description
    countPosts
    seo {
      title
      description
    }
  }
}
    `;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTagQuery(baseOptions?: Apollo.QueryHookOptions<TagQuery, TagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagQuery, TagQueryVariables>(TagDocument, options);
      }
export function useTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagQueryResult = Apollo.QueryResult<TagQuery, TagQueryVariables>;
export const TagPostsCountDocument = gql`
    query TagPostsCount($slug: String) {
  tagCount: tag(where: {slug: $slug}) {
    id
    slug
    countPosts
  }
}
    `;

/**
 * __useTagPostsCountQuery__
 *
 * To run a query within a React component, call `useTagPostsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagPostsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagPostsCountQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTagPostsCountQuery(baseOptions?: Apollo.QueryHookOptions<TagPostsCountQuery, TagPostsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagPostsCountQuery, TagPostsCountQueryVariables>(TagPostsCountDocument, options);
      }
export function useTagPostsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagPostsCountQuery, TagPostsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagPostsCountQuery, TagPostsCountQueryVariables>(TagPostsCountDocument, options);
        }
export type TagPostsCountQueryHookResult = ReturnType<typeof useTagPostsCountQuery>;
export type TagPostsCountLazyQueryHookResult = ReturnType<typeof useTagPostsCountLazyQuery>;
export type TagPostsCountQueryResult = Apollo.QueryResult<TagPostsCountQuery, TagPostsCountQueryVariables>;
export const MainTagPostDocument = gql`
    query MainTagPost($where: PostWhereInput) {
  post: _posts(take: 1, where: $where) {
    nodes {
      ...previewPostWithHtml
    }
  }
}
    ${PreviewPostWithHtmlFragmentDoc}`;

/**
 * __useMainTagPostQuery__
 *
 * To run a query within a React component, call `useMainTagPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainTagPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainTagPostQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMainTagPostQuery(baseOptions?: Apollo.QueryHookOptions<MainTagPostQuery, MainTagPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainTagPostQuery, MainTagPostQueryVariables>(MainTagPostDocument, options);
      }
export function useMainTagPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainTagPostQuery, MainTagPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainTagPostQuery, MainTagPostQueryVariables>(MainTagPostDocument, options);
        }
export type MainTagPostQueryHookResult = ReturnType<typeof useMainTagPostQuery>;
export type MainTagPostLazyQueryHookResult = ReturnType<typeof useMainTagPostLazyQuery>;
export type MainTagPostQueryResult = Apollo.QueryResult<MainTagPostQuery, MainTagPostQueryVariables>;
export const TagPostsDocument = gql`
    query TagPosts($where: PostWhereInput, $skip: Int, $take: Int!) {
  posts: _posts(take: $take, where: $where, skip: $skip) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...previewPost
    }
  }
}
    ${PageInfoFragmentDoc}
${PreviewPostFragmentDoc}`;

/**
 * __useTagPostsQuery__
 *
 * To run a query within a React component, call `useTagPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagPostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useTagPostsQuery(baseOptions: Apollo.QueryHookOptions<TagPostsQuery, TagPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagPostsQuery, TagPostsQueryVariables>(TagPostsDocument, options);
      }
export function useTagPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagPostsQuery, TagPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagPostsQuery, TagPostsQueryVariables>(TagPostsDocument, options);
        }
export type TagPostsQueryHookResult = ReturnType<typeof useTagPostsQuery>;
export type TagPostsLazyQueryHookResult = ReturnType<typeof useTagPostsLazyQuery>;
export type TagPostsQueryResult = Apollo.QueryResult<TagPostsQuery, TagPostsQueryVariables>;
export const JobsAndWorksDocument = gql`
    query JobsAndWorks {
  workArticlesData: _posts(take: 4, where: {tag_slug: {in: ["work"]}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
  jobsData: _posts(take: 5, where: {tag_slug: {in: ["jobs"]}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
}
    ${PageInfoFragmentDoc}
${PostFragmentDoc}`;

/**
 * __useJobsAndWorksQuery__
 *
 * To run a query within a React component, call `useJobsAndWorksQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsAndWorksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsAndWorksQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobsAndWorksQuery(baseOptions?: Apollo.QueryHookOptions<JobsAndWorksQuery, JobsAndWorksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsAndWorksQuery, JobsAndWorksQueryVariables>(JobsAndWorksDocument, options);
      }
export function useJobsAndWorksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsAndWorksQuery, JobsAndWorksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsAndWorksQuery, JobsAndWorksQueryVariables>(JobsAndWorksDocument, options);
        }
export type JobsAndWorksQueryHookResult = ReturnType<typeof useJobsAndWorksQuery>;
export type JobsAndWorksLazyQueryHookResult = ReturnType<typeof useJobsAndWorksLazyQuery>;
export type JobsAndWorksQueryResult = Apollo.QueryResult<JobsAndWorksQuery, JobsAndWorksQueryVariables>;
export const MainWorkArticleDocument = gql`
    query MainWorkArticle {
  _posts(take: 1, where: {tag_slug: {in: ["work"]}}) {
    nodes {
      ...postWithHtml
    }
  }
}
    ${PostWithHtmlFragmentDoc}`;

/**
 * __useMainWorkArticleQuery__
 *
 * To run a query within a React component, call `useMainWorkArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainWorkArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainWorkArticleQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainWorkArticleQuery(baseOptions?: Apollo.QueryHookOptions<MainWorkArticleQuery, MainWorkArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainWorkArticleQuery, MainWorkArticleQueryVariables>(MainWorkArticleDocument, options);
      }
export function useMainWorkArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainWorkArticleQuery, MainWorkArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainWorkArticleQuery, MainWorkArticleQueryVariables>(MainWorkArticleDocument, options);
        }
export type MainWorkArticleQueryHookResult = ReturnType<typeof useMainWorkArticleQuery>;
export type MainWorkArticleLazyQueryHookResult = ReturnType<typeof useMainWorkArticleLazyQuery>;
export type MainWorkArticleQueryResult = Apollo.QueryResult<MainWorkArticleQuery, MainWorkArticleQueryVariables>;
export const WorkArticlesDocument = gql`
    query WorkArticles($cursor: PostWhereUniqueInput, $take: Int!, $skip: Int) {
  _posts(
    cursor: $cursor
    take: $take
    skip: $skip
    where: {tag_slug: {in: ["work"]}}
  ) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
}
    ${PageInfoFragmentDoc}
${PostFragmentDoc}`;

/**
 * __useWorkArticlesQuery__
 *
 * To run a query within a React component, call `useWorkArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkArticlesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useWorkArticlesQuery(baseOptions: Apollo.QueryHookOptions<WorkArticlesQuery, WorkArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkArticlesQuery, WorkArticlesQueryVariables>(WorkArticlesDocument, options);
      }
export function useWorkArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkArticlesQuery, WorkArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkArticlesQuery, WorkArticlesQueryVariables>(WorkArticlesDocument, options);
        }
export type WorkArticlesQueryHookResult = ReturnType<typeof useWorkArticlesQuery>;
export type WorkArticlesLazyQueryHookResult = ReturnType<typeof useWorkArticlesLazyQuery>;
export type WorkArticlesQueryResult = Apollo.QueryResult<WorkArticlesQuery, WorkArticlesQueryVariables>;
export const JobsDocument = gql`
    query Jobs {
  _posts(take: 8, where: {tag_slug: {in: ["jobs"]}}) {
    totalCount
    pageInfo {
      ...pageInfo
    }
    nodes {
      ...post
    }
  }
}
    ${PageInfoFragmentDoc}
${PostFragmentDoc}`;

/**
 * __useJobsQuery__
 *
 * To run a query within a React component, call `useJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobsQuery(baseOptions?: Apollo.QueryHookOptions<JobsQuery, JobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
      }
export function useJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsQuery, JobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
        }
export type JobsQueryHookResult = ReturnType<typeof useJobsQuery>;
export type JobsLazyQueryHookResult = ReturnType<typeof useJobsLazyQuery>;
export type JobsQueryResult = Apollo.QueryResult<JobsQuery, JobsQueryVariables>;